import React from "react";
import OptimizedComponent from "./optimizedComponent";
import {
  routingService,
  authService,
  translateService,
  stateService,
  commonService,
  signService,
  sessionService,
  workSpacesService,
} from "../services/imports";
import { defaults, states } from "../models/imports";
import { stateEvents } from "./../models/states";
import DropDown from "../components/dropDown";
import FacsimileEditor from "./facsimileEditor";
import { organizationName } from "./organizationPicker";
import { LoadingButton } from "./formcontrols/imports";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import {AppContext} from './../Context/AppContext';

export default class PageHeader extends OptimizedComponent {
  constructor(props) {
    super(props);
    this.state = {
      userName: null,
      languagesData: [],
      domains: [],
      organizations: [],
      confirmOrganization: null, // the first switch into it asks first
      enterBusy: false,
      enterError: null,
      confirmLeave: null, // a workspace the caller is a member of, to leave
      leaveBusy: false,
      leaveError: null,
      activeLang: {
        value: defaults.locale.value,
        key: defaults.locale.key,
      },
      workSpaceId: null,
      isLoading: true,
    };

    this.subscriptions = [];
  }

  static contextType = AppContext;

  logout = (e) => {
    e.preventDefault();

    // RP-initiated logout: Keycloak ends the session and returns to /landing
    authService.logout();
  };

  setLang = (lang) => {
    translateService.use(lang.id, lang.key, translateService.changeUserLocale);
    this.setState((prevState) => {
      let activeLang = { ...prevState.activeLang };
      activeLang.value = lang.value;
      activeLang.key = lang.key;

      return { ...prevState, activeLang };
    });
  };

  // the active workspace: remembered in the browser, userInfo does not
  // carry it (sessionService). Workspaces are named by their exposed ids.
  setDomain = (domain) => {
    this.context.setState({ activeDomain: domain.value });
    sessionService.switchTo(domain.exposedId);
  };

  // an enrolled organization: its primary workspace, or the first time in
  // it (asked first, then made)
  enterOrganization = (organization) => {
    if (organization.primaryWorkspaceExposedId != null) {
      sessionService.switchTo(organization.primaryWorkspaceExposedId);
      return;
    }
    this.setState({ confirmOrganization: organization, enterError: null });
  };

  confirmEnter = () => {
    const organization = this.state.confirmOrganization;
    this.setState({ enterBusy: true, enterError: null });
    sessionService.enterOrganization(organization).then(
      () => this.setState({ enterBusy: false, confirmOrganization: null }),
      (e) =>
        this.setState({
          enterBusy: false,
          enterError: signService.problemMessage(e, translateService.t("organization.enterError")),
        })
    );
  };

  // A member leaves a workspace they joined (owner-only "add" and "remove",
  // a member's own "leave", validation-system-api 2026-10-13): the delete of
  // their own membership, by their account id; the lists are read again and
  // the session drops the workspace (the main one when it was active).
  // A workspace the caller owns has key "owner" or "CAN_DELETE"; a joined
  // one, the role's name.
  isMemberOf = (w) => !!w.key && w.key !== "owner" && w.key !== "CAN_DELETE";

  confirmLeaving = () => {
    const w = this.state.confirmLeave;
    const me = this.state.userInfo && this.state.userInfo.id;
    if (!w || me == null) return;
    this.setState({ leaveBusy: true, leaveError: null });
    workSpacesService.deleteUserFromWorkSpace(me, w.exposedId).subscribe(
      () => {
        this.setState({ leaveBusy: false, confirmLeave: null });
        sessionService.reload().catch(() => {});
      },
      (e) =>
        this.setState({
          leaveBusy: false,
          leaveError: signService.problemMessage(e, translateService.t("workspace.leaveError")),
        })
    );
  };

  // the active workspace's name for the switcher and the dashboard
  showActiveDomain = () => {
    const active = this.state.domains.find((w) => w.exposedId === this.state.workSpaceId);
    this.context.setState({ activeDomain: active ? active.value : "" });
  };

  openModalPage = () => {
    const type =
      authService.isAuthenticated() && authService.isActive()
        ? routingService.routeNames.Settings
        : routingService.routeNames.packages;
    stateService.event(stateEvents.openModalPage, type);
  };

  goHome = () => {
    if (authService.isAuthenticated() && authService.isActive() && !authService.hasLinkSession())
      sessionService.reload().catch(() => {});
    routingService.navigate("/");
    stateService.event(stateEvents.openModalPage, null);
  };

  componentDidMount() {
    this.secureSubscription(
      stateService.getState(states.allWorkSpaces).subscribe((data) =>
        this.setState(
          {
            domains: (data && data.workspaces) || [],
            organizations: (data && data.organizations) || [],
            isLoading: false,
          },
          this.showActiveDomain
        )
      )
    );

    this.subscriptions.push(stateService.onEvent(stateEvents.logouted).subscribe(() => {
      this.context.endSugnatureProcess();
      })
    );

    this.secureSubscription(
      stateService.getState(states.allLocales).subscribe((data) => {
        if (!data?.allLocales) {
            return;
        }
        const locales = data.allLocales;
        this.setState({ languagesData: locales }, () => {
          this.secureSubscription(
            stateService.getState(states.userInfo).subscribe((data) => {
              this.setState(
                (prevState) => {
                  let activeLang = { ...prevState.activeLang };

                  let curLang = this.state.languagesData?.filter(
                    (l) => l.id == data.localeId
                  );
                  if (curLang.length) {
                    curLang = curLang[0];
                    activeLang.value = curLang.value;
                    activeLang.key = curLang.key;
                  } else {
                    activeLang.value = defaults.locale.value;
                    activeLang.key = defaults.locale.key;
                  }
                  let workSpaceId = data.workspaceExposedId;
                  let userName = data.mail;
                  let userInfo = { ...data };
               
                  this.context.setState({useFacsimile: data.useFacsimile});
                  this.context.setState({facsimile: data.facsimilePath});
                  return {
                    ...prevState,
                    activeLang,
                    workSpaceId,
                    userName,
                    userInfo,
                  };
                },
                this.showActiveDomain
              );
            })
          );
        });
      })
    );
  }

  /* facsimile */

  startSignatureEditing = () => {
    this.context.setState({showFacsimileModal: true, fromDashboard: false, faximCardInitialized: true, isEditing: this.context.state.useFacsimile > 0});
    // htmlHelperService
    //   .setIdleTimer(10)
    //   .subscribe(() => {
    //     this.context.setState({faximCardInitialized: true, isEditing: this.context.state.useFacsimile > 0});
    //   })
    //   .unsubscribe();
  };

  openSignaturePage = () => {
    stateService.event(stateEvents.openModalPage, routingService.routeNames.signature);
  };

  resetFacsimileStates = () => {
    this.context.setState({activeFacsimileIndex: 1, facsimile: null, isEditing: false, fromDashboard: false});
  };

  componentDidUpdate() {
    if(!authService.isAuthenticated() && this.state.domains?.length) {
    this.setState({domains: [], organizations: []});
    }
  }

  // the switcher: B2C workspaces as before; a corporate login's grouped by
  // organization, an enrolled one without a primary workspace yet entered
  // "for the first time", one not enrolled here shown but not enterable
  renderDomains() {
    const { domains, organizations, workSpaceId } = this.state;
    if (!authService.isAuthenticated() || !authService.isActive() || authService.hasLinkSession() || this.state.isLoading)
      return null;
    const item = (key, label, active, onClick, disabled = false, extra = null) => (
      <div
        key={key}
        onClick={disabled ? undefined : onClick}
        className={`dropDownItem ${active ? "active" : ""} ${disabled ? "disabled" : ""}`}
        aria-disabled={disabled || undefined}
      >
        {label}
        {extra}
      </div>
    );
    // a workspace the caller joined offers "leave" beside its name
    const leave = (w) =>
      this.isMemberOf(w) ? (
        <button
          type="button"
          className="dropDownItem__leave"
          title={translateService.t("workspace.leaveTitle")}
          onClick={(e) => {
            e.stopPropagation();
            this.setState({ confirmLeave: w, leaveError: null });
          }}
        >
          {translateService.t("workspace.leave")}
        </button>
      ) : null;
    const workspaceItem = (w) =>
      item(
        `w-${w.exposedId}`,
        commonService.toShortCode(w.value, 8),
        w.exposedId === workSpaceId,
        () => this.setDomain(w),
        false,
        leave(w)
      );

    if (!organizations.length) {
      if (domains.length == 1 && domains[0]?.exposedId === workSpaceId) return null;
      if (!domains.length) return null;
      return <div className="dropDown">{domains.map(workspaceItem)}</div>;
    }

    const own = domains.filter((w) => !sessionService.organizationOf(w.exposedId));
    return (
      <div className="dropDown">
        {organizations.map((o, i) => (
          <React.Fragment key={o.organizationId || `o-${i}`}>
            <div className="dropDownGroup">{organizationName(o)}</div>
            {!o.enrolled
              ? item(`n-${i}`, translateService.t("organization.notEnrolled"), false, null, true)
              : o.primaryWorkspaceExposedId == null
              ? item(`f-${o.organizationId}`, translateService.t("organization.enterFirst"), false, () => this.enterOrganization(o))
              : (domains.filter((w) => w.exposedId === o.primaryWorkspaceExposedId).length
                  ? domains.filter((w) => w.exposedId === o.primaryWorkspaceExposedId).map(workspaceItem)
                  : [item(`p-${o.organizationId}`, translateService.t("organization.open"), false, () => this.enterOrganization(o))])}
          </React.Fragment>
        ))}
        {own.length > 0 && <div className="dropDownGroup">{translateService.t("organization.ownWorkspaces")}</div>}
        {own.map(workspaceItem)}
      </div>
    );
  }

  renderLeave() {
    const w = this.state.confirmLeave;
    if (!w) return null;
    return (
      <Modal
        isOpen={true}
        fade={false}
        className="first-time-modal"
        toggle={() => !this.state.leaveBusy && this.setState({ confirmLeave: null })}
      >
        <ModalHeader>
          <span>{translateService.t("workspace.leaveTitle")}</span>
        </ModalHeader>
        <ModalBody>
          <p>{translateService.t("workspace.leaveConfirm", w.value)}</p>
          {this.state.leaveError && <p className="color-three" role="alert">{this.state.leaveError}</p>}
          <div className="buttons">
            <LoadingButton
              type="button"
              className="button background-color-three color-white"
              loading={this.state.leaveBusy}
              onClick={this.confirmLeaving}
            >
              {translateService.t("workspace.leave")}
            </LoadingButton>
            <LoadingButton
              type="button"
              className="button background-color-one color-white"
              disabled={this.state.leaveBusy}
              onClick={() => this.setState({ confirmLeave: null })}
            >
              {translateService.t("common.cancell")}
            </LoadingButton>
          </div>
        </ModalBody>
      </Modal>
    );
  }

  renderFirstTime() {
    const organization = this.state.confirmOrganization;
    if (!organization) return null;
    return (
      <Modal
        isOpen={true}
        fade={false}
        className="first-time-modal"
        toggle={() => !this.state.enterBusy && this.setState({ confirmOrganization: null })}
      >
        <ModalHeader>
          <span>{organizationName(organization)}</span>
        </ModalHeader>
        <ModalBody>
          <p>{translateService.t("organization.firstTime", organizationName(organization))}</p>
          {this.state.enterError && <p className="color-three" role="alert">{this.state.enterError}</p>}
          <div className="buttons">
            <LoadingButton
              type="button"
              className="button background-color-two color-white"
              loading={this.state.enterBusy}
              onClick={this.confirmEnter}
            >
              {translateService.t("organization.continue")}
            </LoadingButton>
            <LoadingButton
              type="button"
              className="button background-color-one color-white"
              disabled={this.state.enterBusy}
              onClick={() => this.setState({ confirmOrganization: null })}
            >
              {translateService.t("common.cancell")}
            </LoadingButton>
          </div>
        </ModalBody>
      </Modal>
    );
  }

  render() {
    const languages = (
      <div className="dropDown">
        {this.state.languagesData &&
          this.state.languagesData.map(
            (lang) =>
              lang.value != this.state.activeLang.value && (
                <div
                  key={lang.id}
                  onClick={() => this.setLang(lang)}
                  className={`dropDownItem ${
                    this.state.activeLang.value == lang.value ? "active" : ""
                  }`}
                >
                  <img src={`../../assets/images/${lang.key}.svg`} />
                  {lang.value}
                </div>
              )
          )}
      </div>
    );

    const domains = this.renderDomains();

    return (
      <header className={`header ${translateService.key}`}>
        <div className="header-item-left">
          <div className="logo clickable" onClick={this.goHome}>
            <img src="../../assets/images/logo.svg" className="for-web" />
            <img
              src="../../assets/images/logo-for-small-devices.svg"
              className="for-mobile"
            />
          </div>
          <div
            className={`title ${
              authService.isActive() && authService.isAuthenticated()
                ? "for-web"
                : ""
            }`}
          >
            {translateService.t("common.defaultTitle")}
          </div>
        </div>
        <div className="header-item-right">
          {domains && (
            <div className="account-switcher">
              <DropDown
                current={
                  commonService.toShortCode(this.context.state.activeDomain, 8) ||
                  translateService.t("organization.pick")
                }
                tapImg="../../assets/images/updownarrow.svg"
                className="dropDownComponent"
                activeClassName="active"
                tapClassName="toggle clickable"
              >
                {domains}
              </DropDown>
            </div>
          )}
          {authService.isAuthenticated() &&
            authService.isActive() &&
            this.state.userName && (
              <div className="userEmail">
                <span>{this.state.userName}</span>
                <img src="../../assets/images/man.svg" />
              </div>
            )}
          <div className="lang-switcher">
            <DropDown
              current={
                <div className="activeLang">
                  {" "}
                  <img
                    src={`../../assets/images/${this.state.activeLang.key}.svg`}
                  />
                </div>
              }
              className="dropDownComponent"
              tapClassName="toggle clickable"
            >
              {languages}
            </DropDown>
          </div>
          {authService.isAuthenticated() && authService.isActive() && (
            <div className="hamburger-menu clickable">
              <DropDown
                current={this.state.activeMenu}
                tapImg="../../assets/images/hamburger.svg"
                className="dropDownComponent"
                tapClassName="toggle clickable"
              >
                <div className="dropDown">
                  <div className="dropDownItem" onClick={this.openModalPage}>
                    {translateService.t("common.settings")}
                  </div>
                  <div className="dropDownItem" onClick={this.openSignaturePage}>
                    {translateService.t("common.signature")}
                  </div>
                  <div
                    className="dropDownItem"
                    onClick={this.startSignatureEditing}
                  >
                    {translateService.t("common.facsimile")}
                  </div>
                  <div className="dropDownItem" onClick={this.logout}>
                    {translateService.t("common.logout")}
                  </div>
                </div>
              </DropDown>
            </div>
          )}
        </div>
        {this.renderFirstTime()}
        {this.renderLeave()}
        {!this.context.state.fromDashboard && <FacsimileEditor
          isEditing = {this.context.state.useFacsimile > 0}
          onClosed={this.resetFacsimileStates}
        />}
      </header>
    );
  }
}
